/** Client-side validation failure (form, captcha dismiss, etc.). Distinct from API `@tix/openapi-sdk` ValidationError. */
export default class ValidationError extends Error {
  validationError = true

  constructor(message = 'Validation error') {
    super(message)
    this.name = 'ValidationError'
  }
}

export function isValidationError(error: unknown): error is ValidationError {
  return (error as ValidationError)?.validationError === true
}
